import type { PhoneCommunication } from '@seen/core/models/communications/PhoneCommunication'
import { isOfType } from '@seen/core/utils'
import { Button, DotSeparator, TypographyDetail } from '@seen/ui'
import type { JSX } from 'react'
import { ScrollAreaContent } from '#src/components/core/scroll-area/ScrollAreaContent.tsx'
import { ScrollAreaHeader } from '#src/components/core/scroll-area/ScrollAreaHeader.tsx'
import { Sheet } from '#src/components/core/sheet/Sheet.tsx'
import { SheetContent } from '#src/components/core/sheet/SheetContent.tsx'
import { SheetTrigger } from '#src/components/core/sheet/SheetTrigger.tsx'
import { ParticipantName } from '#src/components/ParticipantName.tsx'
import { RichText } from '#src/components/RichText.tsx'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'

interface PhoneCallItemProps {
  phoneCall: PhoneCommunication
}

export function PhoneCallItem({ phoneCall }: PhoneCallItemProps): JSX.Element {
  return (
    <TimelineTextEntry
      actor={phoneCall.sender ?? 'Unknown'}
      time={phoneCall.startTime ?? null}
      action={
        <>
          {phoneCall.isOutbound && (
            <>
              called{' '}
              <ParticipantName
                participant={
                  phoneCall.subject ??
                  phoneCall.partOf?.find((p) => isOfType(p, 'Patient'))
                }
              />
            </>
          )}
          {!phoneCall.isOutbound && (
            <>
              received a call from{' '}
              <ParticipantName
                participant={
                  phoneCall.subject ??
                  phoneCall.partOf?.find((p) => isOfType(p, 'Patient'))
                }
              />
            </>
          )}
          {phoneCall.duration && (
            <>
              <DotSeparator />
              Duration: {phoneCall.duration}
            </>
          )}
          {phoneCall.message && (
            <>
              <DotSeparator />
              <Sheet>
                <SheetTrigger asChild>
                  <Button variant="link">transcript</Button>
                </SheetTrigger>
                <SheetContent>
                  <ScrollAreaHeader>
                    <div className="flex flex-col">
                      <h5>Transcript</h5>
                      <TypographyDetail className="text-foreground-secondary">
                        Generated by Zoom
                      </TypographyDetail>
                    </div>
                  </ScrollAreaHeader>
                  <ScrollAreaContent className="text-sm">
                    <RichText
                      value={phoneCall
                        .getMessageFormatted()
                        .split('\n')
                        .join('<br /><br />')}
                    />
                  </ScrollAreaContent>
                </SheetContent>
              </Sheet>
            </>
          )}
        </>
      }
      reference={phoneCall.reference}
      originTask={phoneCall.queuedEditsOriginTask}
    />
  )
}
